let tabSelectors = {
    listTrigger: document.querySelector('.sites__optsItem--list'),
    mapTrigger: document.querySelector('.sites__optsItem--map'),
    listElement: document.querySelector('.tabSection--list'),
    mapElement: document.querySelector('.tabSection--map')
};

const DevelopmentTabs = () => {

    let { listTrigger, mapTrigger, listElement, mapElement } = tabSelectors;

    listTrigger.addEventListener('click', () => {
        mapTrigger.classList.remove('sites__optsItem--active');
        listTrigger.classList.add('sites__optsItem--active');
        mapElement.classList.remove('tabSection--active');
        listElement.classList.add('tabSection--active');
    });

    mapTrigger.addEventListener('click', () => {
        listTrigger.classList.remove('sites__optsItem--active');
        mapTrigger.classList.add('sites__optsItem--active');
        listElement.classList.remove('tabSection--active');
        mapElement.classList.add('tabSection--active');
    });

}

export default DevelopmentTabs;


// WEBPACK FOOTER //
// ./src/js/app/components/DevelopmentTabs.js